import React from "react"
import {
  MenuOutlined,
  CloseOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons"
import "./MenuToggleButton.less"

/**
 * Boshliq (2026-09-04): «planshetda menyu chiqaradigan tugma bosilmayapti, juda yomon».
 * O'lchov bilan topilgan sabablar:
 *  1) sudraladigan suzuvchi tugma (0,170) ekranning ENG CHETIDA — iOS «orqaga» imosi zonasi
 *     bilan to'qnashadi, ostidagi sudrash dastagi bilan adashtiradi, menyu bandlari ustida turadi;
 *  2) ochiq menyuning yuqori qismi (logotip, «Поиск по меню») sarlavha (z-index 1000) OSTIDA qolardi;
 *  3) landshaftda (992–1199px) yagona tugma — pastdagi trigger; 100vh tufayli Safari paneli ostida.
 * Yechim: sarlavhaning chap yuqori burchagida DOIMIY 44px tugma (barmoq uchun), hamma sahifada bir joyda.
 */
export default function MenuToggleButton({
  open,
  mobile,
  onClick,
}: {
  open: boolean
  mobile: boolean
  onClick: () => void
}) {
  const label = open ? "Закрыть меню" : "Меню"
  const icon = mobile
    ? open
      ? <CloseOutlined />
      : <MenuOutlined />
    : open
    ? <MenuFoldOutlined />
    : <MenuUnfoldOutlined />
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-expanded={open}
      className={`menu-toggle-btn${open ? " is-open" : ""}${mobile ? " is-mobile" : ""}`}
      onClick={onClick}
    >
      {icon}
    </button>
  )
}
